// extracted by mini-css-extract-plugin
export default {"container":"sessionExpired_container__y2Hlf"};